<template>
    <base-nav class="navbar-top navbar-dark"
              id="navbar-main"
              :show-toggle-button="false"
              expand>
        <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto" style="color:white;">
          <div v-if="showCurrency" class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto" >
            <base-input style="cursor:pointer;">
                <flat-picker slot-scope="{focus, blur}"
                  @on-open="focus"
                  @on-close="blur; getCurrency($event)"
                  :config="{allowInput: true}"
                  class="form-control datepicker"
                  v-model="date"
                  v-on:change="getCurrency($event)"
                  style="cursor:pointer;padding-left:20px">
                </flat-picker>
              </base-input>
            <div class="ml-3" v-if="!errorMessage">
              <span style="font-weight:bold">USD</span>&nbsp;<span>$ {{USD}}</span> <span v-if="!USD">Cargando...</span> |
              <span style="font-weight:bold">EUR</span>&nbsp;<span>$ {{EUR}}</span> <span v-if="!EUR">Cargando...</span>
            </div>
            <div class="ml-3" v-if="errorMessage">
              <span style="font-weight:bold">{{ errorMessage }}</span>
            </div>
          </div>
          <div v-else>
            <base-button  @click="getCurrency" style="cursor:pointer;">
              Mostrar tipo de cambio
            </base-button>
          </div>
        </form>
        <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
                <base-dropdown class="nav-link pr-0">
                    <div class="media align-items-center" slot="title">
                      <span class="avatar avatar-sm rounded-circle">
                        <img alt="Image placeholder" :src="user.photoURL">
                      </span>
                      <div class="media-body ml-2 d-none d-lg-block">
                          <span class="mb-0 text-sm  font-weight-bold">{{user.displayName}} </span>
                      </div>
                    </div>

                    <template>
                        <!-- <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0"></h6>
                        </div> -->
                        <!-- <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-single-02"></i>
                            <span>Backlog</span>
                        </router-link> -->
                        <!-- <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-settings-gear-65"></i>
                            <span>Settings</span>
                        </router-link>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-calendar-grid-58"></i>
                            <span>Activity</span>
                        </router-link>
                        <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-support-16"></i>
                            <span>Support</span> 
                        </router-link>-->
                        <!-- <div class="dropdown-divider"></div> -->
                        <a href="#" class="dropdown-item"  @click="logout">
                            <i class="ni ni-user-run"></i>
                            <span>Cerrar sesión</span>
                        </a>
                    </template>
                </base-dropdown>
            </li>
        </ul>
    </base-nav>
</template>
<script>
  import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import moment from 'moment'
  import axios from 'axios';
import BaseButton from '../components/BaseButton.vue';

  export default {
    components: {
      flatPicker,
      BaseButton
    },
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchQuery: '',
        showCurrency: false,
        user: [],
        EUR: null,
        USD: null,
        date: moment().format("YYYY-MM-DD"),
        dates: {
          simple: moment().format("YYYY-MM-DD")
        },
        errorMessage:null,
      };
    },
    created() {
      const auth = getAuth();
      // Escuchamos los cambios en el estado de autenticación
      onAuthStateChanged(auth, (user) => {
        this.user = user;
      });
    },
    mounted(){
      //this.getCurrency()
    },
    methods: {
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      logout(){
        const auth = getAuth();
        signOut(auth)
          .then(() => {
            this.$router.push("/login");
          })
          .catch((error) => {
            console.error("Error al cerrar sesión:", error);
          });
      },
      getCurrency(event){
        this.showCurrency = true;
        if(event){
          this.date = moment(event[0]).format("YYYY-MM-DD");
        }
        this.EUR = null;
        this.USD = null;
        let fecha = moment(this.date).format('YYYYMMDD');
        // console.log(fecha)
        axios.get(`/api/getCurrencies?date=${fecha}`)
        .then(res => {
          if(res.data.error){
            this.errorMessage="Error al obtener el tipo de cambio"
          }else{
            this.errorMessage=null;
            this.EUR = res.data.EUR;
            this.USD = res.data.USD;
          }
        })
        .catch(err => {
          console.error(err); 
          this.creating = false;
        });
      },
      moment: function () {
        return moment();
      }
    }
  };
</script>
